import { render } from "./SystemUsersPage.vue?vue&type=template&id=06760f45&ts=true"
import script from "./SystemUsersPage.vue?vue&type=script&lang=ts"
export * from "./SystemUsersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/SystemUsersPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06760f45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06760f45', __exports__)) {
    api.reload('06760f45', __exports__)
  }
  
  module.hot.accept("./SystemUsersPage.vue?vue&type=template&id=06760f45&ts=true", () => {
    api.rerender('06760f45', render)
  })

}


export default __exports__